






import { computed, defineComponent, PropType } from "@vue/composition-api";
import { Location } from "vue-router";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import CallsLogger from "@/modules/callsLogger";
import { ROLES } from "@/const";
import { pauseGlobalPlayer } from "@/components/GlobalAudioPlayer/helpers";
import ModalView from "@/components/ModalView/ModalView.vue";
import ConsumeController from "./components/ConsumeController";

export default defineComponent({
  name: "StreamController",
  components: { ModalView, ConsumeController },
  props: {
    user: { type: Object as () => UserPublicData },
    roomId: { type: String },
    back: { type: Object as PropType<Location>, required: true },
  },
  setup(props, { root }) {
    const allowEnterStream = computed(() => {
      return !!props.roomId && (!props.user || checkRole(props.user.role, [ROLES.CREATOR, ROLES.ADMIN]));
    });

    const onClose = () => {
      CallsLogger.collectLogs(`[STREAM CONTROLLER] - Close`, { streaming: false });
      root.$router.push(props.back);
    };

    pauseGlobalPlayer();

    return {
      onClose,
      allowEnterStream,
    };
  },
  beforeRouteEnter(_, __, next) {
    next((vm: any) => {
      if (!vm.allowEnterStream) {
        vm.$router.replace(vm.$props.back);
        return false;
      }
      return true;
    });
  },
});
